import React, {Component} from 'react';

import Rogo from '../static/aka_logo-13.png';

class EnglishFooterManual extends Component {
  render() {
    return (
      <div className="row">
        <div id="footer_logo" className="col-md-2 col-xs-12 ">
          <a href="http://akaintelligence.com">
            <img src={Rogo} alt="goto musio/home" />
          </a>
        </div>
        <div id="footer_copyright" className="col-md-10 col-xs-12">
          <span id="copyright_text">
            ⓒ COPYRIGHT 2016. ALL RIGHTS RESERVED.
          </span>
        </div>
      </div>
    );
  }
}

export default EnglishFooterManual;



// WEBPACK FOOTER //
// ./src/components/EnglishFooter.manual.js